controllers.controller('ReferralActivityController', [
    '$scope', '$state', 'LocaleService', 'constants', '$ionicLoading', 'UserService', 'API', 'Storage', 'ServerTimeService',
    function ($scope, $state, LocaleService, Const, $ionicLoading, UserService, API, Storage, ServerTimeService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });
        $scope.user = UserService.get();

        $scope.signedUpFriends = Storage.get('inviteFriends').filter(function (friend) { return !friend.bonusUsd });
        $scope.qualifiedFriends = Storage.get('inviteFriends').filter(function (friend) { return !!friend.bonusUsd });
        $scope.totalEarnings = $scope.qualifiedFriends.reduce(function (accum, friend) { return (accum + friend.bonusUsd) }, 0);
        $scope.clientTimeZone = ServerTimeService.timeZoneOffset >= 0 ? '+' + ServerTimeService.timeZoneOffset.toString() : ServerTimeService.timeZoneOffset.toString();

        $ionicLoading.hide();

        $scope.activeTab = 'signed_up';


    }]);
